import joi from 'joi';

export const hideJoiPropertyFromDoc = {
  schemaOverride: joi.forbidden(),
};
